import type { PendingChannelPick } from '@/models/insuranceApplication'
import { type QuoteCardData, QuoteCardStage } from './quoteCardTypes'
import { coverageCartKey } from './quoteCartItems'

const CHANNEL_WORDS: Record<PendingChannelPick['channel'], string> = {
  EMAIL: 'email',
  SMS: 'text',
}

/** Cart keys for every priced coverage on the indications the customer picked by email or SMS. */
export function channelPickCartKeys(pick: PendingChannelPick, quotes: QuoteCardData[]): string[] {
  const picked = new Set(pick.indicationIds)
  return quotes.flatMap((quote) =>
    quote.stage === QuoteCardStage.PRICED
      ? quote.coverages
          .filter((coverage) => picked.has(coverage.indicationId ?? quote.id))
          .map((coverage) => coverageCartKey(quote.id, coverage))
      : []
  )
}

/** The cart's note for a pick made by reply, e.g. "You picked Progressive by email. Finish here." */
export function channelPickMessage(pick: PendingChannelPick): string {
  const carriers = new Intl.ListFormat('en', { type: 'conjunction' }).format(pick.vendors) || 'a quote'
  return `You picked ${carriers} by ${CHANNEL_WORDS[pick.channel]}. Finish here.`
}
